export default __webpack_public_path__ + "static/media/eduYellow.8ad4464e.svg";